<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!-- title -->
        <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
          <h4 style="padding-left: 6px"> {{ i18nValues["campaignAdmin"] }} </h4>
          <el-button 
            icon="fas fa-plus" 
            size="small" 
            class="btn-primary" 
            @click="add()"
          > 
            {{ i18nValues["add"] }} 
          </el-button>
        </div>  
      
        <!-- form -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0">
            <div class="filters-wrapper">
              <div class="filters-row">
  
                <!-- search by Name -->
                <el-form-item :label="i18nValues['name']" prop="name">
                  <el-input v-model="filter.name" :placeholder="i18nValues['name']"></el-input>
                </el-form-item> 
                
                <!-- search button  -->
                <el-button
                  @click="retrieveCampaignsBySearch()"
                  icon="fas fa-search"
                  id="searchButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["search"] }}
                </el-button>
              </div>
            </div>
  
            <!-- table -->
            <el-form-item prop="producers">
              <div class="full-width" style="margin:0 auto;padding:20px;">
                  <el-table
                    :key="tableSortKey"
                    :data="CampaingsSubList"
                    id="ProducersTable"
                    class="table table-hover"
                    align="center"
                    :empty-text="i18nValues['noDataAvailable']"
                    :default-sort="tableDefaultSort"
                    stripe
                    @sort-change="handleSortChange"
                  >
  
                    <!-- Campaign Name -->
                    <el-table-column
                      prop="name" 
                      :label= "i18nValues['name']"
                      width="75"
                      align="center"
                      sortable
                    ></el-table-column>
  
                    <!-- Campaign Date-->
                    <el-table-column
                      prop="date" 
                      :label= "i18nValues['date']"
                      :formatter="formatDateCampaign"
                      width="75"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- Campaign Active-->
                    <el-table-column
                      prop="isActive" 
                      :label= "i18nValues['active']"
                      width="75"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- EDIT/DELETE -->
                    <el-table-column width="90" align="right">
                      <template slot-scope="scope">
                        <el-button 
                          v-if="!isReadOnly()"
                          class="text-info"
                          icon="fas fa-edit"
                          size="small"
                          :title="i18nValues['edit']"
                          @click="edit(scope.row.id)"
                        ></el-button>
  
                        <el-button 
                          v-if="!isReadOnly()"
                          class="text-danger"
                          icon="fas fa-times"
                          size="small"
                          :title="i18nValues['remove']"
                          @click="deleteCampaign(scope.row.id)"
                        ></el-button>
                      </template>
                     </el-table-column>                  
                </el-table>
                <div v-if="90 > 10" style="height: 15px"></div>
                  <div class="pagination-bar">
                    <PaginationFunctional
                      ref="pagination"
                      sublistName="CampaingsSubList"
                      :fullList="CampaignsList"
                      :tableSize="20"
                      :tableIndexInitial="initialPage"
                      @paginationChange="paginationChange"
                      @currentIndexPagination="setCurrentPage"
                      class="text-center"
                    /> 
                    <div v-if="CampaignsList.length > 0" class="results-info">
                      <p>
                        {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                      </p>
                    </div>
                  </div>
              </div>
            </el-form-item>      
  
          </el-form>

        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  import PaginationFunctional from "@/components/PaginationFunctional.vue"
  export default {
    name: "CampaignAdmin",
    created() {
      this.restoreFromQuery();
      this.runInitialSearchIfFiltersPresent();
      this.retrieveCampaignCount();
    },
  
    components: {
      PaginationFunctional 
    },
  
  watch: {
      globalFieldSite() {
        this.CampaignsList = []; 
        this.CampaingsSubList = []; 
        this.retrieveCampaigns();
      },
      $route() {
        this.restoreFromQuery();
        this.$nextTick(() => {
          // Check if filters are present in the URL and run search if needed
          if (this.hasFiltersInQuery()) {
            this.retrieveCampaignsBySearch(true); // preservePage = true when loading from URL
          } else {
            // Even without filters, reload campaigns to preserve page/sort from URL
            this.retrieveCampaigns({ 
              preservePage: true, 
              targetPage: this.initialPage || 1 
            });
          }
        });
      }
    },

    computed: {
      loading: get("campaign/loading"),
      globalFieldSite: get("globalFieldSite"),

      // Pagination helpers for results label
      currentPage() {
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        return this.initialPage || 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
        if (typeof this.cantidad === "number") {
          return this.cantidad;
        }
        return Array.isArray(this.CampaignsList) ? this.CampaignsList.length : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },

      tableDefaultSort() {
        if (this.sortProp && this.sortOrder) {
          return { prop: this.sortProp, order: this.sortOrder };
        }
        return {};
      },

      tableSortKey() {
        // Key changes when sort changes, forcing table to re-render with new default-sort
        return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
      },
    },
  
    props:{
      componentsMap: {},
    },
  
    data() {
      return {
        filter: {},
  
        CampaignsList: [],
        CampaingsSubList: [],

        cantidad: 100,
      initialPage: 1,
      sortProp: null,
      sortOrder: null,
      isUpdatingRoute: false,
  
      };
    },
  
    methods: {
      retrieveCampaigns({ preservePage = false, targetPage = null } = {}) {
        this.$store.dispatch("campaign/retrieveAllCampaigns").then((res) => {
          let processedList = res;
          // Translate isActive
          for (let i = 0; i < processedList.length; i++) {
            if (processedList[i].isActive){
              processedList[i].isActive = this.i18nValues["active"];
            } 
          }
          // apply filter if name present (replace full list for pagination correctness)
          if (this.filter && this.filter.name) {
            const name = (this.filter.name || '').toLowerCase().trim();
            processedList = processedList.filter(c => (c.name || '').toLowerCase().includes(name));
          }
          // Apply sorting if sort parameters are present (before setting CampaignsList)
          if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
            const sorted = this.$refs.pagination.handleSortChangePagination({
              prop: this.sortProp,
              order: this.sortOrder
            }, processedList);
            if (Array.isArray(sorted)) {
              processedList = sorted;
            }
          }
          // Set the processed list
          this.CampaignsList = processedList;
          
          // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
          const resolvedTarget = typeof targetPage === "number" && targetPage > 0
            ? targetPage
            : this.initialPage || 1;
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(resolvedTarget);
              }
            });
          });
          // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
          if (!preservePage) {
            this.updateRouteQuery();
          }
          // When preservePage is true, the URL already has the correct state, so we don't update it
        });
      },
  
      retrieveCampaignsBySearch(preservePage = false) {
        const name = (this.filter && this.filter.name ? this.filter.name : '').toLowerCase().trim();
        if (!name) {
          // no filter -> reload full list
          this.retrieveCampaigns({ preservePage });
          return;
        }
        // Need to reload full list first to get all campaigns, then filter
        this.$store.dispatch("campaign/retrieveAllCampaigns").then((res) => {
          let processedList = res;
          // Translate isActive
          for (let i = 0; i < processedList.length; i++) {
            if (processedList[i].isActive){
              processedList[i].isActive = this.i18nValues["active"];
            } 
          }
          // Apply filter
          processedList = processedList.filter((campaign) => {
            return (campaign.name || '').toLowerCase().includes(name);
          });
          
          // Apply sorting if sort parameters are present
          if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
            const sorted = this.$refs.pagination.handleSortChangePagination({
              prop: this.sortProp,
              order: this.sortOrder
            }, processedList);
            if (Array.isArray(sorted)) {
              processedList = sorted;
            }
          }
          
          this.CampaignsList = processedList;
          
          const targetPage = preservePage ? this.initialPage || 1 : 1;
          if (!preservePage) {
            this.initialPage = 1;
          }
          
          // Sync pagination after loading
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(targetPage);
              }
            });
          });
          
          // Update URL after search
          if (preservePage) {
            this.updateRouteQuery();
          } else {
            this.updateRouteQuery({ page: 1 });
          }
        });
      },
  
      add() {
        this.$router.push({
          name: `CampaignEdition`,
          params: { id: "0" },
          query: this.$route.query,
        });
      },
  
      edit(id) {
        this.$router.push({
          name: `CampaignEdition`,
          params: { id: id },
          query: this.$route.query,
        });

      },
  
      deleteCampaign(id) {
        this.$confirm(this.i18nValues["deleteCampaignMessage"], this.i18nValues["deleteCamapign"], { 
                distinguishCancelAndClose: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("campaign/deleteCampaign" , id).then((res)=>{
                if (res.status == "OK") {
                    this.$notify.success({
                    title: this.i18nValues["success"],
                    message: this.i18nValues["campaignDeleted"],
                    position: "bottom-right",
                    });
                    // After delete, reload using current filters/sort and keep pagination state
                    this.runInitialSearchIfFiltersPresent();
                    this.$root.$refs.App.retrieveAllCampaigns();
                    this.retrieveCampaignCount();
                } else if(res.statusDescription != null){
                    this.$notify.error({
                    title: this.i18nValues["error"],
                    message: res.statusDescription,
                    position: "bottom-right",
                    });
                } else {
                    this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["campaignDeletError"],
                    position: "bottom-right",
                    });
                }       
                });
            });
      },

      retrieveCampaignCount() {
        this.$store
          .dispatch("campaign/countCampaigns")
          .then((res) => {
            this.cantidad = res;
          });
      },

      formatDateCampaign(row){
        return this.formatDate(row.date);
      },
  
      handleSortChange(event) {
        const nextProp = event && event.prop ? event.prop : null;
        const nextOrder = event && event.order ? event.order : null;
        const sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
        this.sortProp = nextProp;
        this.sortOrder = nextOrder;
        if (sortChanged) {
          this.CampaignsList = this.$refs.pagination.handleSortChangePagination(event);
          this.initialPage = 1;
          this.updateRouteQuery({
            sortProp: this.sortProp || undefined,
            sortOrder: this.sortOrder || undefined,
            page: 1,
          });
          this.$nextTick(() => {
            if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
              this.$refs.pagination.currentChange(1);
            }
          });
        } else {
          this.CampaignsList = this.$refs.pagination.handleSortChangePagination(event);
        }
      },

      paginationChange(evt) {
        if (evt && evt.list) {
          this.CampaingsSubList = evt.list;
        }
        const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
        this.updateRouteQuery({ page: currentIdx });
      },

      setCurrentPage(idx) {
        if (typeof idx === 'number') {
          this.updateRouteQuery({ page: idx });
        }
      },

      hasFiltersInQuery() {
        const q = this.$route.query || {};
        return !!(
          q.name ||
          // Also check component state in case query hasn't updated yet
          (this.filter && this.filter.name)
        );
      },

      runInitialSearchIfFiltersPresent() {
        if (this.hasFiltersInQuery()) {
          this.retrieveCampaignsBySearch(true); // preservePage = true when loading from URL
        } else {
          // Even without filters, we need to load campaigns and preserve page/sort from URL
          this.retrieveCampaigns({ 
            preservePage: true, 
            targetPage: this.initialPage || 1 
          });
        }
      },

      // --- Query sync helpers ---
      restoreFromQuery() {
        const q = this.$route.query || {};
        this.filter = this.filter || {};
        if (q.name) this.filter.name = q.name;
        this.initialPage = q.page ? Number(q.page) : 1;
        this.sortProp = q.sortProp || null;
        this.sortOrder = q.sortOrder || null;
      },

      updateRouteQuery(partial) {
        const base = this.buildQueryFromState();
        const next = Object.assign({}, base, partial || {});
        const cleaned = {};
        Object.keys(next).forEach(k => {
          const v = next[k];
          if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
        });
        this.isUpdatingRoute = true;
        const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
        this.$router.replace({ query: cleaned }).then(done).catch(done);
      },

      buildQueryFromState() {
        const q = {};
        if (this.filter && this.filter.name) q.name = this.filter.name;
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
        else if (this.initialPage) q.page = this.initialPage;
        if (this.sortProp) q.sortProp = this.sortProp;
        if (this.sortOrder) q.sortOrder = this.sortOrder;
        return q;
      },
  }
  
  };
  
  </script>

<style scoped>
.filters-wrapper {
  margin-bottom: 20px;
}

.filters-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row .el-input,
.filters-row .el-select {
  width: 180px;
}

.filters-row .el-input >>> .el-input__inner,
.filters-row .el-select >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-date-editor {
  width: 180px;
}

.filters-row .el-date-editor >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>